<template>
  <WdsRadioGroup v-model:checked="internalModelValue" :name="name">
    <WdsRadio value="de_freelancer" :disabled="disabled">
      <WdsText
        :text="$t('Freiberufler/in (Freelancer)')"
        :sub-text="
          $t(
            'The work you perform is registered as freelance work (Freiberufliche Tätigkeit) with the tax office (Finanzamt)',
          )
        "
      />
    </WdsRadio>
    <WdsRadio value="de_tradesperson" :disabled="disabled">
      <WdsText
        :text="$t('Gewerbetreibende/r (Tradesperson)')"
        :sub-text="$t('You are registered as a tradesperson with the tax office (Finanzamt)')"
      />
    </WdsRadio>
    <WdsRadio value="de_entrepreneurial" :disabled="disabled">
      <WdsText
        :text="$t('UG (Entrepreneurial Company)')"
        :sub-text="
          $t(
            'You have a UG (Unternehmergesellschaft) listed with the trade register (Handelsregister)',
          )
        "
      />
    </WdsRadio>
    <WdsRadio value="de_limited" :disabled="disabled">
      <WdsText
        :text="$t('GmbH (Limited Company)')"
        :sub-text="$t('You have a GmbH listed with the trade register (Handelsregister)')"
      />
    </WdsRadio>
  </WdsRadioGroup>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { WdsRadio, WdsRadioGroup, WdsText } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const internalModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
